<div class="v2-page">

  <div class="v2-head">
    <h2>User &amp; Group Management</h2>
    <span class="v2-sub">Employees, groups &amp; billing</span>
  </div>

  <mat-tab-group animationDuration="0ms" class="v2-tabs">

    <!-- ============================ EMPLOYEES ============================ -->
    <mat-tab label="Employees">
      <div class="v2-tab-body">
        <div class="v2-toolbar">
          <mat-form-field appearance="outline" class="v2-search">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Search name, email or code</mat-label>
            <input matInput #empSearchInput (keyup)="applyEmpFilter($event)">
          </mat-form-field>
          <span class="v2-spacer"></span>
          <button mat-stroked-button color="primary" (click)="importEmployees()">
            <mat-icon>upload_file</mat-icon> Import from Excel
          </button>
          <button mat-flat-button color="primary" (click)="addEmployee()">
            <mat-icon>person_add</mat-icon> Add employee
          </button>
        </div>

        <div class="v2-table-wrap">
          <table mat-table [dataSource]="employees" matSort #empSort="matSort" class="v2-mat-table">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let m">{{ m.name }}</td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
              <td mat-cell *matCellDef="let m">{{ m.email }}</td>
            </ng-container>
            <ng-container matColumnDef="employeeCode">
              <th mat-header-cell *matHeaderCellDef>Code</th>
              <td mat-cell *matCellDef="let m">{{ m.employeeCode }}</td>
            </ng-container>
            <ng-container matColumnDef="group">
              <th mat-header-cell *matHeaderCellDef>Group</th>
              <td mat-cell *matCellDef="let m">{{ groupName(m.groupId) }}</td>
            </ng-container>
            <ng-container matColumnDef="credit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit</th>
              <td mat-cell *matCellDef="let m">{{ m.credit }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let m">
                <button class="v2-pill" [class.on]="m.status" (click)="toggleActive(m)">
                  {{ m.status ? 'Active' : 'Inactive' }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let m">
                <button mat-icon-button [matMenuTriggerFor]="empMenu"><mat-icon>more_vert</mat-icon></button>
                <mat-menu #empMenu="matMenu">
                  <button mat-menu-item (click)="editEmployee(m)"><mat-icon>edit</mat-icon> Edit</button>
                  <button mat-menu-item (click)="openCredit(m)"><mat-icon>account_balance_wallet</mat-icon> Adjust credit</button>
                  <button mat-menu-item (click)="openLedger(m)"><mat-icon>receipt_long</mat-icon> View ledger</button>
                  <button mat-menu-item (click)="deleteEmployee(m)"><mat-icon color="warn">delete</mat-icon> Remove</button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="empColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: empColumns;"></tr>
          </table>
          <div class="v2-empty" *ngIf="employees.data.length === 0">No employees yet.</div>
        </div>
        <mat-paginator #empPaginator [pageSize]="25" [pageSizeOptions]="[10,25,50,100]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-tab>

    <!-- ============================ GROUPS ============================ -->
    <mat-tab label="Groups">
      <div class="v2-tab-body">
        <div class="v2-toolbar">
          <p class="v2-note">The <strong>customer (kundekort)</strong> is billed; the <strong>systems</strong> are where members log in &amp; buy.</p>
          <span class="v2-spacer"></span>
          <button mat-flat-button color="primary" (click)="addGroup()">
            <mat-icon>group_add</mat-icon> Add group
          </button>
        </div>

        <div class="v2-table-wrap">
          <table mat-table [dataSource]="groups" matSort #groupSort="matSort" class="v2-mat-table">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let g">{{ g.name }}</td>
            </ng-container>
            <ng-container matColumnDef="groupId">
              <th mat-header-cell *matHeaderCellDef>Group ID</th>
              <td mat-cell *matCellDef="let g">{{ g.groupId }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let g">{{ groupType(g) }}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Credit / Subsidy</th>
              <td mat-cell *matCellDef="let g">{{ groupAmount(g) }}</td>
            </ng-container>
            <ng-container matColumnDef="customer">
              <th mat-header-cell *matHeaderCellDef>Customer (billed)</th>
              <td mat-cell *matCellDef="let g">{{ customerName(g.customerId) }}</td>
            </ng-container>
            <ng-container matColumnDef="systems">
              <th mat-header-cell *matHeaderCellDef>Systems</th>
              <td mat-cell *matCellDef="let g" class="v2-systems-cell">{{ systemsLabel(g) }}</td>
            </ng-container>
            <ng-container matColumnDef="accumulate">
              <th mat-header-cell *matHeaderCellDef>Accum.</th>
              <td mat-cell *matCellDef="let g">{{ g.worker === 'creditRenew' ? (g.accumulate ? 'Yes' : 'No') : '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let g">
                <button mat-icon-button [matMenuTriggerFor]="groupMenu"><mat-icon>more_vert</mat-icon></button>
                <mat-menu #groupMenu="matMenu">
                  <button mat-menu-item (click)="editGroup(g)"><mat-icon>edit</mat-icon> Edit</button>
                  <button mat-menu-item (click)="deleteGroup(g)"><mat-icon color="warn">delete</mat-icon> Remove</button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="groupColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: groupColumns;"></tr>
          </table>
          <div class="v2-empty" *ngIf="groups.data.length === 0">No groups yet.</div>
        </div>
        <mat-paginator #groupPaginator [pageSize]="25" [pageSizeOptions]="[10,25,50,100]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
